import React, { useEffect, useState, FC, useContext } from 'react';
import {
  Box,
  Button,
  createTheme,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  ThemeProvider,
  Typography,
  useTheme,
} from '@mui/material';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';
import { useTranslation } from 'react-i18next';

interface Props {
  question: any;
  step: number;
  onChange: (qid: string, val: string, i: number, p: boolean) => Promise<void>;
  value?: string;
}

const CustomQuestionDropdown: FC<Props> = ({ question, step, onChange, value }) => {
  const theme = useTheme();
  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();

  return (
    <Box>
      <FormGroup>
        <FormControl
          size="small"
          sx={{ minWidth: '17.75rem' }}
        >
          <Select
            labelId="select-label"
            value={value}
            onChange={async (e: SelectChangeEvent) => {
              await onChange(question.questionId || '', e.target.value, step, false);
            }}
          >
            {question.options.map((option: any, index: any) => (
              <MenuItem
                key={index}
                value={option.label}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FormGroup>
    </Box>
  );
};

export default CustomQuestionDropdown;
